<template>
    <div class="w-ludovico" :class="{ 'w-is-loaded': !!loaded }">
        <Header />
        <List />
    </div>
</template>

<script>
import Header from './components/Header.vue';
import List from './components/List.vue';

export default {
    name: 'App',
    components: {
        Header,
        List,
    },
    data() {
        return {
            loaded: false,
        };
    },
    computed: {},
    mounted: function() {
        this.$nextTick(function() {
            setTimeout(() => {
                this.loaded = true;
            }, 1);
        });
    },
};
</script>

<style lang="scss">
@import '@/styles/_base.scss';
@import '@/styles/objects/_format.scss';

.w-ludovico {
    opacity: 0;
    transition: opacity $w-transition * 2 w-get-easing('smooth');
    &.w-is-loaded {
        opacity: 1;
    }

    background-color: w-get-color("lightgray");

    user-select: none;
}
</style>
